'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.millisecondFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/millisecondFromNow.js
// module id = 347
// module chunks = 1